import LANG from './en'

/**
 * demographics data is available for
 */
export const DEMOGRAPHICS = [
  {
    id: 'all',
    label: LANG['LABEL_ALL'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'w',
    label: LANG['LABEL_W'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'b',
    label: LANG['LABEL_B'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'h',
    label: LANG['LABEL_H'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'a',
    label: LANG['LABEL_A'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'm',
    label: LANG['LABEL_M'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'f',
    label: LANG['LABEL_F'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'p',
    label: LANG['LABEL_P'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  },
  {
    id: 'np',
    label: LANG['LABEL_NP'],
    regions: ['states','districts'],
    vars: ['all_frl','all_prm']
  }
]

/**
 * gaps data is available for
 */
export const GAPS = []
// export const NO_DEMOGRAPHICS = {
//   'ses': [
//     'm',
//     'f',
//     'p',
//     'np'
//   ]
// }
/**
 * Demographic IDs that have a FRL gap chart
 * (Free and reduced lunch)
 */
export const FRL_GAP_DEMOGRAPHICS = [
  'all',
  'w',
  'a',
  'b',
  'h',
  'm',
  'f',
  'wb',
  'wh',
  'p',
  'np'
]
/**
 * Demographic IDs that have a SES gap chart
 * (Socioeconomic difference)
 */
export const SES_GAP_DEMOGRAPHICS = []
/**
 * Demographic IDs that have a SEG gap chart
 * (difference in exposure to poor students)
 */
export const SEG_GAP_DEMOGRAPHICS = []
/**
 * Demographic IDs that have a MIN gap chart
 * (difference in exposure to minority students)
 */
export const MIN_GAP_DEMOGRAPHICS = []

/**
 * Demographic IDs that have a ESSER_PER_STUDENT gap chart
 * (ESSER funding per student)
 */
export const PEF_GAP_DEMOGRAPHICS = [
  'all',
  'w',
  'a',
  'b',
  'h',
  'm',
  'f',
  'p',
  'np',
  // 'np',
  // 'wb',
  // 'wh',
  // 'pn'
]

/**
 * Demographic IDs that have a PCT_REMOTE gap chart
 * (Percent of year remote)
 */
export const PRM_GAP_DEMOGRAPHICS = [
  'all',
  'w',
  'a',
  'b',
  'h',
  'm',
  'f',
  'p',
  'np',
  // 'wb',
  // 'wh',
  // 'pn'
]